import { useState, useEffect } from 'react'
import { ReactComponent as LirariLandingPageMobileLogo } from './../../assets/images/lirari-landing-page-mobile-logo.svg'
import { useAuth0 } from '@auth0/auth0-react'
import userClient from '../../Api/Lirari/Clients/userClient'
import { UserTypes } from '../../Api/Lirari/Types/userTypes'
import { User } from '../../Api/Lirari/Types/user'
import { useNavigate } from 'react-router-dom'

const RedirectPage = () => {
  const { user, getAccessTokenSilently } = useAuth0()
  const [userObject, setUserObject] = useState<User>()

  const navigate = useNavigate()

  useEffect(() => {
    // Check if email is verified
    if (user && !user.email_verified) {
      navigate('/verify-email')
      return
    }

    const setUserTypeAsync = async () => {
      const lirariUser = await userClient.getUserByAuth0Id(user!.sub!, await getAccessTokenSilently())
      if (lirariUser == null) {
        navigate('/choose')
      } else {
        setUserObject(lirariUser)
      }
    }

    if (user?.sub) {
      setUserTypeAsync()
    }
  }, [user?.sub, user?.email_verified, getAccessTokenSilently, user, navigate])

  useEffect(() => {
    if (userObject?.userType == UserTypes.Musician) {
      navigate(`/u/${userObject?.id}`)
    } else if (userObject?.userType == UserTypes.Seeker) {
      navigate('/search')
    } else {
      console.error(
        '[RedirectPage] Problem with redirect page, please contact support',
        userObject,
        userObject?.userType,
        UserTypes.Musician,
        UserTypes.Seeker,
      )
    }
  }, [userObject, navigate])

  return (
    <div className="bg-white flex flex-col h-[100vh]">
      <div className="flex flex-row items-center justify-center">
        <LirariLandingPageMobileLogo className="h-[25rem]" />
      </div>
      <div className="flex flex-row justify-center items-center">
        <div className="flex flex-col justify-center items-center">
          <p className="text-[55px] lg:text-[70px] text-black m-0">lirari</p>
          <p className="text-[20px] lg:text-[25px] text-black m-0">The Professional</p>
          <p className="text-[20px] lg:text-[25px] text-black m-0">Musician Network</p>
        </div>
      </div>
    </div>
  )
}

export default RedirectPage
